import { ChevronLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/cn';

/** פס הודעה עליון, butter. גובה 44 לפחות. השברון של "להגשה" מצביע שמאלה ב RTL. */
export function AnnouncementBand({
  icon: Icon,
  children,
  to,
  actionLabel,
  className,
}: {
  icon?: LucideIcon;
  children: React.ReactNode;
  to?: string;
  actionLabel?: string;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex min-h-11 items-center gap-2 bg-butter px-4 py-2 text-body-sm text-ink',
        className,
      )}
    >
      {Icon && <Icon size={20} strokeWidth={1.75} aria-hidden="true" className="shrink-0" />}
      <span className="flex-1">{children}</span>
      {to && actionLabel && (
        <Link to={to} className="inline-flex items-center gap-1 font-medium text-ink underline">
          {actionLabel}
          <ChevronLeft size={20} strokeWidth={1.75} aria-hidden="true" />
        </Link>
      )}
    </div>
  );
}
